import React, { useState } from 'react';
import FormSkel from './FormSkel';

export default function ManufacturerForm({ handleClose, handleSubmit, manufacturerData }) {
  const [data, setData] = useState(
    manufacturerData || { Name: '', Code: '', Country: '', IsActive: true, IsEditable: true }
  );
  const [initialData] = useState(
    manufacturerData || { Name: '', Code: '', Country: ''}
  )

  const isUnchanged = Object.keys(initialData).every(
    key => String(data[key]) === String(initialData[key])
  );

  const onChange = (field) => (e) => {
    let val = e.target.value;

    if (field === 'Code') {
      val = val.toUpperCase();
      val = val.replace(/[^A-Z]/g, '');
    }
    setData((prev) => ({ ...prev, [field]: val }));
  };

  return (
    <FormSkel
      headerText={manufacturerData ? 'Edytuj producenta' : 'Nowy producent'}
      onKeyDown={(evt) => evt.key === 'Enter' && evt.preventDefault()}
      data={data}
      deleteDisable={manufacturerData ? false : true}
      handleClose={handleClose}
      handleSubmit={(evt) => handleSubmit(evt, data, setData)}
      disableSubmit={!data.Name || !/^[A-Z]{3}$/.test(data.Code) || !data.Country || isUnchanged}
    >
      <form
        autoComplete="off"
        id="modal-form"
        onKeyDown={(evt) => evt.key === 'Enter' && evt.preventDefault()}
        onSubmit={(evt) => handleSubmit(evt, data, setData)}
      >
        <div className="mb-3">
          <label className="h6">Nazwa</label>
          <input
            autoComplete="off"
            name="name"
            className={`form-control ${!data.Name && 'invalid-input'}`}
            value={data.Name}
            maxLength={249}
            onChange={onChange('Name')}
            disabled={!data.IsEditable}
            placeholder="Wpisz nazwę producenta"
          />
        </div>

        <div className="mb-3">
          <label className="h6">Kod</label>
          <input
            autoComplete="off"
            name="code"
            className={`form-control ${!/^[A-Z]{3}$/.test(data.Code) && 'invalid-input'}`}
            value={data.Code}
            maxLength={3}
            onChange={onChange('Code')}
            disabled={!data.IsEditable}
            placeholder="Kod (3 wielkie litery)"
          />
        </div>

        <div className="mb-3">
          <label className="h6">Kraj</label>
          <input
            autoComplete="off"
            name="country"
            className={`form-control ${!data.Country && 'invalid-input'}`}
            value={data.Country}
            maxLength={249}
            onChange={onChange('Country')}
            disabled={!data.IsEditable}
            placeholder="Wpisz kraj"
          />
        </div>
      </form>
    </FormSkel>
  );
}
